import React from 'react';

/**
 * Full-page loading indicator. Used as the Suspense fallback for the
 * top-level <Suspense> in src/index.js — shown briefly while the main
 * bundle's lazy-loaded chunks are being fetched.
 *
 * Why a custom one instead of an inline <Spin />?
 * - Avoids importing antd's <Spin> at the top level (we want the first
 *   paint to be as small as possible).
 * - Zero JS dependencies — pure CSS animation, ~250 bytes gzipped.
 * - Branded to match the app's primary color (#057CE4).
 *
 * The keyframes are injected via a <style> tag so this component works
 * without a global stylesheet. We use a stable id so React only renders
 * it once even if the component mounts multiple times.
 */
const STYLE_ID = 'app-fullpage-loader-style';

const injectKeyframes = () => {
  if (typeof document === 'undefined') return;
  if (document.getElementById(STYLE_ID)) return;
  const tag = document.createElement('style');
  tag.id = STYLE_ID;
  tag.textContent = `
    @keyframes app-loader-spin {
      0%   { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
    .app-fullpage-loader {
      position: fixed;
      inset: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: rgba(255, 255, 255, 0.96);
      z-index: 9999;
      gap: 16px;
    }
    .app-fullpage-loader__spinner {
      width: 48px;
      height: 48px;
      border: 4px solid #e5e7eb;
      border-top-color: #057CE4;
      border-radius: 50%;
      animation: app-loader-spin 0.8s linear infinite;
    }
    .app-fullpage-loader__label {
      font-family: 'DM Sans', system-ui, -apple-system, sans-serif;
      color: #4b5563;
      font-size: 14px;
      font-weight: 500;
      letter-spacing: 0.2px;
    }
  `;
  document.head.appendChild(tag);
};

const FullPageLoader = ({ message = 'Memuat aplikasi…' }) => {
  React.useEffect(() => {
    injectKeyframes();
  }, []);

  return (
    <div className="app-fullpage-loader" role="status" aria-live="polite" aria-busy="true">
      <div className="app-fullpage-loader__spinner" aria-hidden="true" />
      <div className="app-fullpage-loader__label">{message}</div>
    </div>
  );
};

export default FullPageLoader;
